import {Component, Vue} from 'vue-facing-decorator';
import Loading from 'vue-loading-overlay';
import ax from '@/utils/axios';
import {authStatus} from '@/utils/auth';

@Component({
    components: {       
        'loading'    : Loading,
    }
})
export default class App extends Vue {
    isAppLoading = false;
    async mounted() {
        try {
            const response = await ax.get('admin/config/base/get_base_config');
            if (response.data.status) {
                this.$store.commit('baseData/setBaseData', response.data.data.profile);
                this.$store.dispatch('baseConfig/setConfig', response.data.data.setting);
                this.$store.dispatch('baseConfig/setDefault', response.data.data.default);
            }
            this.isAppLoading = false;
        } catch (error) {
            this.isAppLoading = false;
        }
        
        this.checkSession();
    }

    checkSession() {
        //console.log('cek status')
        this.isAppLoading = true;
        const auth_status : any = authStatus();
        auth_status.then( (res : any) => {
            //console.log( res);
            this.isAppLoading = false;
            if (res) {
                if(this.$route.path && this.$route.path != '/'){
                    this.$router.push(this.$route.path);
                }else{
                    this.$router.push('/home');
                }
            } else {
                if(this.$route.name != 'Login'){
                    this.$toast.add({ severity: 'warn',  summary: 'Load', detail: res.message, life: 3000 });
                }
                this.$router.push('login');
            }
        }).catch((err :any) => {
            //console.log( err);
            this.isAppLoading = false;
            if(this.$route.name != 'Login'){
                this.$toast.add({ severity: 'error',  summary: 'Load', detail: err.message, life: 3000 });
            }
            this.$router.push('/login');
        })
    }
    
    get app_base_data(): any {
        return this.$store.state.baseData;
    }

    
}